/**
 * Links aus fremden Daten.
 *
 * Der Bericht zeigt Quellenangaben, die aus den Belegen eines Persona-Sets
 * stammen. Die hat ein Kunde eingetragen, und ein Bericht wird
 * weitergeleitet — an seinen Kunden, an dessen Geschäftsführung. Eine
 * `javascript:`-URL darin wäre ein Loch, das über zwei Ecken aufgeht.
 *
 * Eigenes Modul mit Tests, aus demselben Grund wie [`ziel.ts`](./ziel.ts): das
 * ist eine Sicherheitsfunktion und keine Anzeigelogik.
 *
 * Erlaubnisliste, keine Sperrliste. `http` und `https`, sonst nichts —
 * `mailto:` und `tel:` fehlen mit Absicht, weil in diesem Feld nie eines steht
 * und jede zusätzliche Zulassung eine zusätzliche Kante ist.
 */

export function sichererLink(wert: unknown): string | null {
  const roh = String(wert ?? '').trim();
  if (!roh) return null;
  // Steuerzeichen koennen ein Schema verstecken: "java\nscript:alert(1)"
  // liest der Browser als javascript:.
  if (/[ -]/.test(roh)) return null;
  if (!/^https?:\/\//i.test(roh)) return null;
  try {
    const u = new URL(roh);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}
